import { Box, Button, Link } from '@nimbus-ds/components';
import { trackingSavedSearchQuickSave } from 'domains/Orders/tracking';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface FilterModalFooterProps {
  showSaveSearchOption: boolean;
  disabledCreateSavedSearchOption: boolean;
  openSavedSearchModal: () => void;
  handleCancel: () => void;
  handleConfirm: () => void;
  savedSearchModalMode?: 'create' | 'edit';
  isConfirmDisabled?: boolean;
}

export function FilterModalFooter({
  showSaveSearchOption,
  disabledCreateSavedSearchOption,
  openSavedSearchModal,
  handleCancel,
  handleConfirm,
  savedSearchModalMode,
  isConfirmDisabled,
}: Readonly<FilterModalFooterProps>) {
  const t = useTranslationOrders();

  const handleOpenSavedSearchModal = () => {
    trackingSavedSearchQuickSave('filter_modal');
    openSavedSearchModal();
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      width="100%"
      flex="1"
    >
      {showSaveSearchOption && !savedSearchModalMode && (
        <Box display="flex" alignItems="center">
          <Link
            as="button"
            textDecoration="none"
            appearance={disabledCreateSavedSearchOption ? 'neutral' : 'primary'}
            disabled={disabledCreateSavedSearchOption}
            onClick={handleOpenSavedSearchModal}
          >
            {t('savedSearches.saveFilter')}
          </Link>
        </Box>
      )}
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="flex-end"
        gap="4"
        flex="1"
      >
        <Button onClick={handleCancel}>
          {t(savedSearchModalMode ? 'filter.cancel' : 'filter.cleanFilter')}
        </Button>
        <Button
          onClick={handleConfirm}
          appearance="primary"
          disabled={isConfirmDisabled}
        >
          {t(
            !savedSearchModalMode
              ? 'filter.filter'
              : savedSearchModalMode === 'create'
              ? 'filter.create'
              : 'filter.save',
          )}
        </Button>
      </Box>
    </Box>
  );
}
